import type { InputSource } from '@/types/InputSource.ts';
import { useSourceStore } from '@/stores/SourceStore.ts';
import { useSettingsStore } from '@/stores/SettingsStore.ts';
import { AuthenticationService } from '@/services/AuthenticationService.ts';
import { isInputSourceAutoDetected } from '@/utils/AutoDetectUtils.ts';
import { setInputSourceAction } from '@/actions/app/SetInputSourceAction.ts';
import { createTextToast } from '@/utils/ToastUtils.ts';

export const handleRequestSourcesResponseAction = async (sources: InputSource[]) => {
    const hostStore = useSourceStore();
    hostStore.sources = sources;
    hostStore.sourcesLoading = false;

    const settingStore = useSettingsStore();

    // Ignore response if not logged in or still onboarding
    if (
        hostStore.selectedSourceId ||
        !AuthenticationService.instance.isLoggedIn() ||
        settingStore.isOnboarding
    ) {
        return;
    }

    // Try to automatically assign a valid source
    for (const source of sources) {
        const autoDetected = isInputSourceAutoDetected(source.name);

        if (autoDetected) {
            void setInputSourceAction(source);

            createTextToast(`Input source automatically detected.`, source.name, 'success', true);

            return;
        }
    }
};
